module.exports = __webpack_public_path__ + "img/btn_google_dark_focus_ios.ef5056c5.svg";